import TextInput from "components/form/input/TextInput"
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields"
import MudaMecanizada from ".."

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={MudaMecanizada.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Observação">
                        <TextInput name="obs" label="Observação" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Tamanho dos Toletes Picados">
                        <TextInput name="tamToletesPicados" label="Tamanho dos Toletes Picados (%)" type="number" />
                        {/* <TextInput name="minRegular" label="Mínimo para Regular (%)" type="number" />
                        <TextInput name="minRegular" label="Mínimo para Bom (%)" type="number" />
                        <TextInput name="minRegular" label="Mínimo para Ótimo (%)" type="number" /> */}
                    </ParamFormRow>
                    <ParamFormRow label="Meta Entrenós Rachados">
                        <TextInput name="entrenosRachados" label="Entrenós Rachados (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Nós Rachados">
                        <TextInput name="nosRachados" label="Nós Rachados (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Gemas Danificadas">
                        <TextInput name="gemasDanificadas" label="Gemas Danificadas (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Palmito Agregado">
                        <TextInput name="palmitoAgregado" label="Palmito Agregado (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    )
}
